<router-outlet></router-outlet>

<!-- App-brede settings-paneel-host, gebonden aan de centrale HdChartSettingsStore. -->
<hd-chart-settings-panel
  [(open)]="store.panelOpen"
  [colorConfig]="store.colorConfig()"
  [colorConfigPresetId]="store.colorConfigPresetId()"
  [planetGridColorConfig]="store.planetGridColorConfig()"
  [planetGridColorConfigPresetId]="store.planetGridColorConfigPresetId()"
  [planetGridVisualizationMode]="store.planetGridVisualizationMode()"
  [showChiron]="store.showChiron()"
  [showAstroPositions]="store.showAstroPositions()"
  [includeNonHdFeatures]="store.includeNonHdFeatures()"
  [gateInfoOpenBehavior]="store.gateInfoOpenBehavior()"
  [docLinkOpenBehavior]="store.docLinkOpenBehavior()"
  [contextMenuEnabled]="store.chartContextMenuEnabled()"
  [channelHighlightEnabled]="store.channelHighlightEnabled()"
  [dimOnHover]="store.dimOnHover()"
  [hoverHighlightColor]="store.hoverHighlightColor()"
  [highlightGatePieces]="store.highlightGatePieces()"
  [dimOneSideOnly]="store.dimOneSideOnly()"
  [basicPanelChartLink]="store.basicPanelChartLink()"
  [communityContentEnabled]="store.communityContentEnabled()"
  [alternativeIChingEnabled]="store.alternativeIChingEnabled()"
  [raLineTextsEnabled]="store.raLineTextsEnabled()"
  [ownLineTextsEnabled]="store.ownLineTextsEnabled()"
  [lineTextReviewFeatureGranted]="lineTextReviewAccess.featureGranted()"
  [classicIChingEnabled]="store.classicIChingEnabled()"
  [classicIChingFeatureGranted]="ichingAccess.featureGranted()"
  [classicIChingIconsChart]="store.classicIChingIconsChart()"
  [classicIChingIconsTransits]="store.classicIChingIconsTransits()"
  [keynotesAtHoverOnly]="store.keynotesAtHoverOnly()"
  [showBothCenterStateSections]="store.showBothCenterStateSections()"
  [gateInfoFromChannelSeparateToDock]="store.gateInfoFromChannelSeparateToDock()"
  [advancedBridgeCalculation]="store.advancedBridgeCalculation()"
  [bridgeGateStyle]="store.bridgeGateStyle()"
  [moonTransitConnectorStyle]="store.moonTransitConnectorStyle()"
  [moonTransitGateMarkerStyle]="store.moonTransitGateMarkerStyle()"
  [justNowTransitColorMode]="store.justNowTransitColorMode()"
  [mandalaQuarterColorVariant]="store.mandalaQuarterColorVariant()"
  [mandalaZodiacRingVariant]="store.mandalaZodiacRingVariant()"
  [mandalaSliceCenterFade]="store.mandalaSliceCenterFade()"
  [shortcutButtonSize]="store.shortcutButtonSize()"
  [chartMatchScope]="store.chartMatchScope()"
  [gateGraphPalette]="store.gateGraphPalette()"
  [showPrint]="showPrint()"
  (colorConfigPresetChange)="store.handleColorConfigPresetChange($event)"
  (planetGridColorConfigPresetChange)="store.handlePlanetGridColorConfigPresetChange($event)"
  (visualizationStyleChange)="store.handleVisualizationStyleChange($event)"
  (gateInfoOpenBehaviorChange)="store.handleGateInfoOpenBehaviorChange($event)"
  (gateGraphPaletteChange)="store.handleGateGraphPaletteChange($event)"
  (docLinkOpenBehaviorChange)="store.handleDocLinkOpenBehaviorChange($event)"
  (contextMenuEnabledToggled)="store.handleContextMenuEnabledToggled()"
  (channelHighlightToggled)="store.handleChannelHighlightToggled()"
  (dimOnHoverToggled)="store.toggleDimOnHover()"
  (hoverHighlightColorChange)="store.handleHoverHighlightColorChange($event)"
  (highlightGatePiecesToggled)="store.toggleHighlightGatePieces()"
  (dimOneSideOnlyToggled)="store.toggleDimOneSideOnly()"
  (basicPanelChartLinkToggled)="store.toggleBasicPanelChartLink()"
  (communityContentEnabledToggled)="store.toggleCommunityContentEnabled()"
  (alternativeIChingEnabledToggled)="store.toggleAlternativeIChing()"
  (raLineTextsEnabledToggled)="store.toggleRaLineTexts()"
  (ownLineTextsEnabledToggled)="store.toggleOwnLineTexts()"
  (lineTextReviewRequested)="lineTextReviewPanel.openOverview()"
  (classicIChingEnabledToggled)="store.toggleClassicIChing()"
  (classicIChingIconsChartToggled)="store.toggleClassicIChingIconsChart()"
  (classicIChingIconsTransitsToggled)="store.toggleClassicIChingIconsTransits()"
  (keynotesAtHoverOnlyToggled)="store.toggleKeynotesAtHoverOnly()"
  (showBothCenterStateSectionsToggled)="store.toggleBothCenterStateSections()"
  (gateInfoFromChannelSeparateToDockToggled)="store.handleGateInfoFromChannelSeparateToDockToggled()"
  (includeNonHdFeaturesToggled)="store.toggleIncludeNonHdFeatures()"
  (shortcutButtonSizeChange)="store.shortcutButtonSize.set($event)"
  (chartMatchScopeChange)="store.chartMatchScope.set($event)"
  (printRequested)="onPrint()"
  (resetToDefaultsRequested)="store.resetToDefaults()"
></hd-chart-settings-panel>
